import moment from 'moment';

import { getDefaultValueForType } from '../../../lib/helpers';

const getInitialListData = (
  properties = {},
  schema = {},
  list = [],
  hasData = false,
) => {
  const data = [];
  list.forEach((item) => {
    const itemData = getInitialData(properties, schema, item, hasData);
    data.push(itemData);
  });
  return data;
};

const isValidType = (value, fieldSchema) => {
  if (!value || (Array.isArray(value) && !value.length)) return true;
  if (fieldSchema.type === 'array') {
    if (!Array.isArray(value)) return false;
    if (fieldSchema.items?.$ref) {
      return !value.some((item) => !item?.dataUrl);
    }
    return true;
  }
  return typeof value === fieldSchema.type;
};

export const getInitialData = (properties, schema, contentObject, hasData) =>
  Object.keys(properties).reduce((initials, key) => {
    const defaultDate = moment(
      schema[key].default,
      moment.ISO_8601,
      true,
    ).isValid()
      ? schema[key].default
      : null;

    const defaultValue =
      properties[key].inputType === 'dateTime'
        ? defaultDate
        : schema[key].default;

    const defaultForType = getDefaultValueForType(schema[key].type);

    const isValid = isValidType(contentObject[key], schema[key]);

    let init = hasData && isValid ? contentObject[key] : defaultValue;

    if (schema[key].type === 'object' && Array.isArray(init)) {
      init = {};
    } else if (properties[key].inputType === 'object') {
      init = getInitialListData(
        properties[key].items.propertiesConfig,
        schema[key].items.properties,
        contentObject[key],
        hasData,
      );
    }

    initials[key] = init || defaultForType;

    return initials;
  }, {});
